import React, { Component } from 'react';
import { connect }          from 'react-redux';
import Filtro               from "../img/global/filtro.svg";
import { GetCheckSelect }   from '../actions/scopoAction';

class renderFiltro extends Component {
    render() {
        return (
             <div className="filtro">
                <div className="btn-group ">
                    <div className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <img src={Filtro} alt="" />
                    </div>
                    <ul className="dropdown-menu">
                        <li><a href={void(0)} onClick={()=>this.props.GetCheckSelect(null)}>ATIVOS</a></li>
                        <li><a href={void(0)} onClick={()=>this.props.GetCheckSelect(1)}>NÃO ATIVOS</a></li>
                    </ul>
                </div>
            </div>
        );
    }
}
export default connect(null,{GetCheckSelect})(renderFiltro);




// WEBPACK FOOTER //
// ./src/container/renderFiltro.js